<template>
  <div>
    <validation-provider
      #default="{ errors }"
      name="city"
      :rules="requiredField ? 'required' : ''"
    >
      <b-form-group
        label="Municípios"
        label-for="city"
      >
        <v-select
          id="city"
          v-model="city"
          :class="errors.length > 0 ? 'error-select' : ''"
          :filter="fuseSearch"
          label="nome"
          :options="dataOptions"
          :placeholder="'Municípios'"
          :disabled="readonly"
          :clearable="!readonly"
          @open="onCreate()"
        >
          <template #option="{ nome }">
            <span>{{ nome }}</span>
          </template>

          <template #selected-option="{ nome }">
            <span>{{ nome | truncate(truncateField, '...') }}</span>
          </template>

          <template #no-options>
            Não há opções de municípios.
          </template>
        </v-select>
        <small class="text-danger">{{ errors[0] }}</small>
      </b-form-group>
    </validation-provider>
  </div>
</template>
<script>
import {
  BFormGroup,
} from 'bootstrap-vue'

import {
  ValidationProvider,
} from 'vee-validate'

import {
  required,
} from '@validations'

import vSelect from 'vue-select'
import Fuse from 'fuse.js'
import truncate from '@/components/utils/filters/truncate'
import syslic from '@/syslic'

export default {
  components: {
    BFormGroup,
    ValidationProvider,
    vSelect,
  },
  filters: {
    truncate,
  },
  model: {
    prop: 'cityValue',
    event: 'cityChange',
  },
  props: {
    cityValue: {
      type: [Object, String],
      required: false,
      default: null,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    requiredField: {
      type: Boolean,
      required: false,
      default: false,
    },
    truncateField: {
      type: Number,
      required: false,
      default: 17,
    },
  },
  data() {
    const dataOptions = []
    const newCityValue = this.cityValue

    return {
      dataOptions,
      newCityValue,
      required,
    }
  },
  computed: {
    city: {
      get() {
        return this.newCityValue
      },
      set(value) {
        this.newCityValue = value
        this.$emit('cityChange', this.newCityValue)
      },
    },
  },
  watch: {
    cityValue(newVal) {
      this.newCityValue = newVal
    },
  },
  created() {
    this.onCreate()
  },
  methods: {
    onCreate() {
      syslic
        .pncp
        .cities
        .fetchCities()
        .then(response => {
          this.dataOptions = response
          this.$emit('ready', true)
        })
        .catch(() => {
          this.$emit('ready', true)
        })
    },
    fuseSearch(options, search) {
      const fuse = new Fuse(options, {
        keys: ['nome'],
        shouldSort: true,
      })
      return search.length
        ? fuse.search(search).map(({ item }) => item)
        : fuse.list
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
<style lang="scss" scoped>
.v-select {
  background-color: #fff;
}
</style>
